import React, { useEffect, useState } from 'react';
import Box from '@mui/material/Box';
import { DataGrid } from '@mui/x-data-grid';
import { destroy, index } from '../../api/usersApi';
import { Stack } from '@mui/system';
import { Button, Card, Grid, IconButton, Tooltip } from '@mui/material';
import { Add, Delete, Edit, Search } from '@mui/icons-material';
import MercadappDialog from '../../components/MercadappDialog';
import withShowAlert from '../../components/withShowAlert';
import FormDialog from './FormDialog';
import { useNavigate } from 'react-router-dom';


function Users({ showAlert }) {

  let navigate = useNavigate();
  const columns = [
    {
      field: 'email',
      headerName: 'E-mail',
      width: 200,
    },
    {
      field: 'role',
      headerName: 'Nível',
      flex: 1,
    },
    {
      headerName: 'Ações',
      width: 210,
      renderCell: (params) => (
        <Stack direction="horizontal">
          <Tooltip title="Editar">
            <IconButton color="info" onClick={() => setFormModalInfo({ editingModel: params.row, open: true })}>
              <Edit />
            </IconButton>
          </Tooltip>
          <Tooltip title="Excluir">
            <IconButton color="error" onClick={() => setDeleteModalOpen({ id: params.row.id, open: true })}>
              <Delete />
            </IconButton>
          </Tooltip>
        </Stack>
      )
    }
  ];

  const [formModalInfo, setFormModalInfo] = useState({ editingModel: null, open: false })
  const [cancelModalInfo, setDeleteModalOpen] = useState({ id: null, loading: false, open: false })
  const [data, setData] = useState([])
  const [isLoading, setIsLoading] = useState(false)

  const loadData = async () => {
    setIsLoading(true)
    const response = await index()
    setData(response.data)
    setIsLoading(false)
  }

  const callDestroyRequest = async (credentialId) => {
    try {
      await destroy(credentialId)
      showAlert('Deletado com sucesso', 'success')
      loadData()
    } catch (error) {
      console.log(error)
      showAlert('Falha ao deletar.', 'error')
    }
  }

  useEffect(() => {
    loadData()
  }, [])

  return (
    <Box sx={{ height: '82vh', width: '100%' }}>
      {formModalInfo.open &&
        <FormDialog
          editingModel={formModalInfo.editingModel}
          open={formModalInfo.open}
          setOpen={(open, reload, message) => {
            setFormModalInfo({ ...formModalInfo, open: open })
            if (reload) {
              showAlert(message, "success")
              loadData()
            }
          }} />
      }
      <MercadappDialog title="Tem certeza?" message="O registro selecionado será removido permanentemente."
        open={cancelModalInfo.open}
        setOpen={(open) => setDeleteModalOpen({ ...cancelModalInfo, open: open })}
        buttons={
          [{
            text: "Cancelar", color: "primary", action: () => {
              setDeleteModalOpen({ open: false, id: null })
            }
          }]
        }
        loadingButtons={[{
          text: "Confirmar",
          loading: cancelModalInfo.loading,
          color: "error",
          action: () => {
            callDestroyRequest(cancelModalInfo.id)
            setDeleteModalOpen({ open: false, id: null })
          }
        }]} />
      <Grid justifyContent="end" container mb={2}>
        <Button startIcon={<Add />} variant="contained" color="success" onClick={() => setFormModalInfo({ editingModel: null, open: true })}>
          Novo 
        </Button>
      </Grid>

      <Card>
      <DataGrid
        rows={data || []}
        columns={columns}
        loading={isLoading}
        autoHeight={true}
        disableSelectionOnClick
        hideFooterSelectedRowCount={true}
        disableColumnSelector
        disableColumnMenu
        disableColumnFilter
        sx={{
          '.MuiTablePagination-displayedRows': {
            display: 'none'
          },
          '.MuiTablePagination-selectLabel': {
            display: 'none'
          },
          '.MuiInputBase-root': {
            display: 'none'
          }
        }}

      />
      </Card>
    </Box >
  );
}

export default withShowAlert(Users)